/*
 * VestiZen - extras da versao Shopify
 * - Botao de compra da pagina de produto: limpa o carrinho, adiciona o VestiZen e vai direto ao checkout.
 * - Valores aproximados do texto (custos de clinica, "40p", "pounds") na moeda do visitante.
 *   Preco, compare-at e "Save" ja vem prontos do Liquid (mesmo valor do checkout).
 * Sem tracking, sem chamadas externas.
 */
(function () {
  "use strict";

  var VZ = window.VZ || {};

  function setupAtc() {
    var btns = document.querySelectorAll("[data-vestizen-atc]");
    if (!btns.length || !VZ.variantId) return;
    var busy = false;
    btns.forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault();
        if (busy) return;
        busy = true;
        b.style.opacity = "0.7";
        var root = VZ.root || "/";
        fetch(root + "cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json" } })
          .then(function () {
            return fetch(root + "cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ items: [{ id: VZ.variantId, quantity: 1 }] })
            });
          })
          .then(function (r) { if (!r.ok) throw new Error("add failed"); window.location.href = root + "checkout"; })
          .catch(function () {
            var f = document.getElementById("vz-atc-form");
            if (f) f.submit(); else { busy = false; b.style.opacity = ""; }
          });
      });
    });
  }

  function nice(v) {
    if (v >= 1000) return Math.round(v / 100) * 100;
    if (v >= 100) return Math.round(v / 10) * 10;
    return Math.round(v);
  }

  function setupApprox() {
    var cur = VZ.currency, price = VZ.priceCents, gbp = VZ.gbpPriceCents || 4999;
    if (!cur || cur === "GBP" || !price) return;
    var rate = price / gbp;
    var words = { USD: "dollars", EUR: "euros" };
    var loc = cur === "USD" ? "en-US" : "en-IE";
    function fmt(v, dec) {
      try {
        return new Intl.NumberFormat(loc, { style: "currency", currency: cur, minimumFractionDigits: dec, maximumFractionDigits: dec }).format(v);
      } catch (e) { return cur + " " + v.toFixed(dec); }
    }
    document.querySelectorAll(".vz-money").forEach(function (el) {
      var t = el.dataset.type, g = parseFloat(el.dataset.gbp);
      if (t === "word") el.textContent = words[cur] || el.textContent;
      else if (t === "pence") {
        var c = Math.round(g * rate * 100);
        el.textContent = cur === "USD" ? c + "¢" : fmt(c / 100, 2);
      } else if (t === "approx") el.textContent = fmt(nice(g * rate), 0);
    });
  }

  function init() { setupAtc(); setupApprox(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
